(function () {
  function clamp(el) {
    if (el.dataset.overflowGuarded) return;
    el.dataset.overflowGuarded = '1';
    el.style.setProperty('max-width', '100vw', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
  }

  function check(el) {
    if (!(el instanceof Element)) return;
    if (getComputedStyle(el).position !== 'fixed') return;
    var rect = el.getBoundingClientRect();
    if (rect.width > window.innerWidth + 1 || rect.right > window.innerWidth + 1 || rect.left < -1) {
      clamp(el);
    }
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    check(root);
    var descendants = root.querySelectorAll('*');
    for (var i = 0; i < descendants.length; i++) check(descendants[i]);
  }

  function scanBody() {
    if (document.body) scan(document.body);
  }

  if (document.readyState === 'complete') {
    setTimeout(scanBody, 300);
  } else {
    window.addEventListener('load', function () {
      setTimeout(scanBody, 300);
    });
  }

  // Some popups/widgets inject after a delay (e.g. timed campaigns). Re-check
  // for ~20s after load, then rely on the MutationObserver below.
  var rechecks = 0;
  var interval = setInterval(function () {
    rechecks++;
    scanBody();
    if (rechecks >= 10) clearInterval(interval);
  }, 2000);

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) scan(added[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
